import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "flex h-full w-full min-w-0 flex-col gap-5 overflow-y-auto overflow-x-hidden p-4 pt-20 xl:p-8 xl:pt-8" };
const _hoisted_2 = { class: "flex flex-col gap-2" };
const _hoisted_3 = { class: "text-2xl font-bold tracking-tight text-eblack-900" };
const _hoisted_4 = { class: "text-sm text-eblack-500" };
const _hoisted_5 = { class: "flex flex-col gap-3.5" };
const _hoisted_6 = { class: "relative w-full md:max-w-md" };
const _hoisted_7 = ["placeholder"];
const _hoisted_8 = {
    key: 0,
    class: "flex flex-wrap items-center gap-3"
};
const _hoisted_9 = { class: "flex flex-wrap gap-2" };
const _hoisted_10 = ["onClick"];
const _hoisted_11 = { class: "ml-auto whitespace-nowrap text-sm text-eblack-500" };
const _hoisted_12 = {
    key: 0,
    class: "rounded-xl border border-red-200 bg-red-50 p-8 text-center text-sm text-red-700"
};
const _hoisted_13 = {
    key: 1,
    class: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-x-6 gap-y-8"
};
const _hoisted_14 = {
    key: 2,
    class: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-x-6 gap-y-8"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = { class: "relative aspect-[20/19] w-full overflow-hidden rounded-xl bg-gradient-to-b from-ewhite-100 to-ewhite-200/80 ring-1 ring-black/[0.05]" };
const _hoisted_17 = ["src", "alt"];
const _hoisted_18 = {
    key: 1,
    class: "flex h-full w-full flex-col items-center justify-center gap-2 text-eblack-300 transition-transform duration-300 group-hover:scale-105"
};
const _hoisted_19 = { class: "flex h-12 w-12 items-center justify-center rounded-2xl bg-white/80 shadow-sm ring-1 ring-black/[0.04] backdrop-blur-sm" };
const _hoisted_20 = { class: "text-[11px] font-medium tracking-wider uppercase text-eblack-400" };
const _hoisted_21 = {
    key: 2,
    class: "absolute left-3 top-3 inline-flex items-center gap-1.5 rounded-full border border-white/40 bg-white/85 px-2.5 py-1 text-xs font-semibold text-eblack-800 shadow-[0_2px_8px_rgba(0,0,0,0.08)] ring-1 ring-black/[0.04] backdrop-blur-md"
};
const _hoisted_22 = ["disabled", "aria-label", "onClick"];
const _hoisted_23 = {
    key: 4,
    class: "absolute inset-x-0 bottom-3 flex justify-center"
};
const _hoisted_24 = { class: "flex items-center gap-1.5 rounded-full bg-black/30 px-2 py-1 backdrop-blur-md" };
const _hoisted_25 = { class: "flex flex-col px-0.5 pt-3" };
const _hoisted_26 = { class: "flex items-start justify-between gap-3" };
const _hoisted_27 = { class: "line-clamp-2 text-[15px] font-semibold leading-5 tracking-tight text-eblack-900 transition-colors group-hover:text-eblack-950" };
const _hoisted_28 = {
    key: 0,
    class: "flex h-5 flex-shrink-0 items-center gap-1 text-[13px] font-semibold text-eblack-900"
};
const _hoisted_29 = { class: "font-normal text-eblack-400" };
const _hoisted_30 = {
    key: 1,
    class: "flex h-5 flex-shrink-0 items-center gap-1 text-xs font-medium text-eblack-500"
};
const _hoisted_31 = { class: "mt-1 line-clamp-1 text-[13px] font-medium text-eblack-700" };
const _hoisted_32 = { class: "mt-0.5 line-clamp-1 text-[13px] text-eblack-500" };
const _hoisted_33 = { class: "mt-0.5 text-[13px] text-eblack-500" };
const _hoisted_34 = { class: "mt-3.5 flex items-center justify-between border-t border-ewhite-200/80 pt-3" };
const _hoisted_35 = { class: "flex flex-col gap-1" };
const _hoisted_36 = {
    key: 0,
    class: "flex flex-wrap items-baseline gap-1 text-[13px] leading-tight"
};
const _hoisted_37 = { class: "text-xs text-eblack-500" };
const _hoisted_38 = { class: "font-bold text-eblack-900" };
const _hoisted_39 = { class: "text-xs text-eblack-500" };
const _hoisted_40 = {
    key: 1,
    class: "flex flex-wrap items-baseline gap-1 text-[11px] leading-tight text-eblack-500"
};
const _hoisted_41 = { class: "font-semibold text-eblack-700" };
const _hoisted_42 = {
    key: 2,
    class: "text-xs font-medium text-eblack-500"
};
const _hoisted_43 = { class: "ml-auto flex items-center gap-1" };
const _hoisted_44 = ["title", "aria-label", "onClick"];
const _hoisted_45 = ["onClick"];
const _hoisted_46 = {
    key: 3,
    class: "flex flex-col items-center justify-center rounded-2xl border border-ewhite-200 bg-ewhite-50 px-8 py-16 text-center"
};
const _hoisted_47 = { class: "flex h-[72px] w-[72px] items-center justify-center rounded-full bg-ewhite-100" };
const _hoisted_48 = { class: "mt-4 text-lg font-semibold text-eblack-900" };
const _hoisted_49 = { class: "mt-2 max-w-sm text-sm leading-relaxed text-eblack-500" };
import { i18n } from "@/i18n";
import { computed, onMounted, ref, unref } from "vue";
import { IconCalendarEvent, IconMessageCircle, IconPhoto, IconSearch, } from "@tabler/icons-vue";
import { useToast } from "vue-toastification";
import { useAbility } from "@/domains/auth";
import { useConversationCreation } from "@/domains/conversation";
import { useCatalogServiceStore } from "@/domains/service/stores/catalog-service.store";
import { getCountryName } from "@/utils/country-name";
import { useOverlay } from "@/services/overlay-service";
import { createModalConfig } from "@/utils/overlay-utils";
import { calendarRepository } from "@domains/scheduling/repositories/calendar.repository";
import { computePriceRange, } from "@domains/scheduling/utils/price-range";
import { computeCommissionAmountRange } from "@domains/scheduling/utils/commission-amount-range";
import CatalogServiceDetailModal from "./components/CatalogServiceDetailModal.vue";
import ServiceCatalogCardSkeleton from "./components/ServiceCatalogCardSkeleton.vue";
import PriceRangeFilter from "./components/PriceRangeFilter.vue";
import ServiceScheduleModal from "@/pages/admin/child-pages/Services/components/ServiceScheduleModal.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ServiceCatalogIndex',
    setup(__props) {
        const toast = useToast();
        const { can } = useAbility();
        const { findOrRedirect, isCreating: isCreatingConversation } = useConversationCreation();
        const catalogServiceStore = useCatalogServiceStore();
        const overlayService = useOverlay();
        const search = ref("");
        const activeCategory = ref(null);
        const isInitialLoading = ref(true);
        const detailOverlayId = ref(null);
        const priceRanges = ref({});
        const commissionAmounts = ref({});
        const priceFilter = ref(null);
        const canCreateConversation = computed(() => can("create", "Conversation"));
        const availableCategories = computed(() => {
            const names = catalogServiceStore.services
                .map((service) => service.category?.name)
                .filter((name) => Boolean(name));
            return [...new Set(names)].sort((a, b) => a.localeCompare(b));
        });
        /** Starting price of every priced service; feeds the price filter histogram. */
        const servicePrices = computed(() => Object.values(priceRanges.value).map((range) => range.min));
        function matchesPriceRange(service, filter) {
            if (!filter)
                return true;
            const range = priceRanges.value[service.id];
            return Boolean(range) && range.min <= filter.max && range.max >= filter.min;
        }
        function filterServices(price) {
            const value = search.value.trim().toLowerCase();
            return catalogServiceStore.services.filter((service) => {
                if (!matchesPriceRange(service, price))
                    return false;
                if (activeCategory.value &&
                    service.category?.name !== activeCategory.value) {
                    return false;
                }
                if (!value)
                    return true;
                return [
                    service.name,
                    service.description,
                    service.additional_information,
                    service.provider?.name,
                    service.category?.name,
                    service.service_type?.name,
                    service.country,
                    service.location_one,
                    service.location_two,
                    service.location_three,
                ]
                    .filter(Boolean)
                    .some((item) => String(item).toLowerCase().includes(value));
            });
        }
        const filteredServices = computed(() => filterServices(priceFilter.value));
        function countForPriceRange(range) {
            return filterServices(range).length;
        }
        const hasActiveFilters = computed(() => Boolean(search.value.trim()) ||
            activeCategory.value !== null ||
            priceFilter.value !== null);
        function selectCategory(category) {
            activeCategory.value = category;
        }
        function clearFilters() {
            search.value = "";
            activeCategory.value = null;
            priceFilter.value = null;
        }
        function durationLabel(duration) {
            if (!duration)
                return "Duración no especificada";
            if (duration < 60)
                return `${duration} min`;
            const hours = Math.floor(duration / 60);
            const minutes = duration % 60;
            return minutes ? `${hours} h ${minutes} min` : `${hours} h`;
        }
        function locationLabel(service) {
            const country = service.country ? getCountryName(service.country) : null;
            return [
                country,
                service.location_one,
                service.location_two,
                service.location_three,
            ]
                .filter(Boolean)
                .join(", ");
        }
        function servicePhotoUrls(service) {
            return [...(service.photoUrls ?? []), ...(service.photo_urls ?? [])]
                .filter(Boolean)
                .filter((url, index, urls) => urls.indexOf(url) === index);
        }
        function firstPhoto(service) {
            return servicePhotoUrls(service)[0] ?? null;
        }
        /**
         * Loads each service's availability rules to derive the starting per-person
         * price and commission shown on the card. Mirrors ServiceIndex.fetchServiceRates:
         * the `/catalog/services` list payload carries no price, and rates can change,
         * so the card shows a "from" value computed from the rules.
         */
        async function fetchServiceRates(services) {
            const results = await Promise.allSettled(services
                .filter((service) => service.id != null)
                .map(async (service) => [
                service.id,
                await calendarRepository.getAvailabilityRules(service.id),
            ]));
            const price = {};
            const commission = {};
            for (const result of results) {
                if (result.status !== "fulfilled")
                    continue;
                const [id, rules] = result.value;
                const priceRange = computePriceRange(rules);
                if (priceRange)
                    price[id] = priceRange;
                const commissionAmount = computeCommissionAmountRange(rules);
                if (commissionAmount)
                    commission[id] = commissionAmount;
            }
            priceRanges.value = price;
            commissionAmounts.value = commission;
        }
        async function loadServices() {
            try {
                const data = await catalogServiceStore.fetchServices(true);
                fetchServiceRates(data);
            }
            catch {
                toast.error(i18n.global.t("services.auto.no_se_pudieron_cargar_los_servicios_bzgxb"));
            }
            finally {
                isInitialLoading.value = false;
            }
        }
        async function openPreBookingChat(service) {
            await findOrRedirect({ serviceId: String(service.id) });
        }
        function openServiceSchedule(service) {
            overlayService.open(createModalConfig({
                component: ServiceScheduleModal,
                size: "md",
                props: { service },
            }));
        }
        async function openServiceDetail(service) {
            const overlayId = overlayService.open(createModalConfig({
                component: CatalogServiceDetailModal,
                size: "xl",
                props: buildDetailModalProps(service),
                events: {
                    chat: openPreBookingChat,
                },
                onClose: () => {
                    if (detailOverlayId.value === overlayId) {
                        detailOverlayId.value = null;
                    }
                },
            }));
            detailOverlayId.value = overlayId;
            try {
                const detailedService = await catalogServiceStore.fetchServiceById(service.id);
                if (detailOverlayId.value === overlayId) {
                    overlayService.updateProps(overlayId, buildDetailModalProps(detailedService));
                }
            }
            catch {
                toast.error(i18n.global.t("services.auto.no_se_pudo_cargar_el_detalle_del_servicio"));
            }
        }
        function buildDetailModalProps(service) {
            return {
                service,
                canCreateConversation: canCreateConversation.value,
                isCreatingConversation: Boolean(unref(isCreatingConversation)),
            };
        }
        onMounted(loadServices);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("services.auto.servicios")), 1),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("services.auto.catalogo_de_servicios_disponibles_para_itinerari")), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_unref(IconSearch), { class: "absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-eblack-400" }),
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((search).value = $event)),
                            type: "text",
                            class: "h-12 w-full rounded-xl border border-ewhite-300 bg-white px-4 pl-10 text-sm text-eblack-900 placeholder:text-eblack-400 focus:border-eblack-400 focus:ring-0",
                            placeholder: _ctx.$t('services.auto.buscar_servicios_o_proveedores')
                        }, null, 8, _hoisted_7), [
                            [_vModelText, search.value]
                        ])
                    ]),
                    (isInitialLoading.value || _unref(catalogServiceStore).services.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["rounded-full border px-4 py-1.5 text-[13px] font-semibold transition",
                                        activeCategory.value === null
                                            ? 'border-eblack-900 bg-white text-eblack-900 shadow-[inset_0_0_0_1px_#333333]'
                                            : 'border-ewhite-300 bg-white text-eblack-700 hover:border-eblack-300'
                                    ]),
                                    onClick: _cache[1] || (_cache[1] = ($event) => (selectCategory(null)))
                                }, _toDisplayString(_ctx.$t("services.auto.todos")), 3),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableCategories.value, (category) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                        key: category,
                                        type: "button",
                                        class: _normalizeClass(["rounded-full border px-4 py-1.5 text-[13px] font-semibold transition",
                                            activeCategory.value === category
                                                ? 'border-eblack-900 bg-white text-eblack-900 shadow-[inset_0_0_0_1px_#333333]'
                                                : 'border-ewhite-300 bg-white text-eblack-700 hover:border-eblack-300'
                                        ]),
                                        onClick: ($event) => (selectCategory(category))
                                    }, _toDisplayString(category), 11, _hoisted_10));
                                }), 128)),
                                _createVNode(PriceRangeFilter, {
                                    modelValue: priceFilter.value,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((priceFilter).value = $event)),
                                    prices: servicePrices.value,
                                    "count-for": countForPriceRange
                                }, null, 8, ["modelValue", "prices"])
                            ]),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("services.auto.n_servicios", {
                                count: filteredServices.value.length,
                            })), 1)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                (_unref(catalogServiceStore).error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t("services.auto.no_se_pudieron_cargar_los_servicios")), 1))
                    : (isInitialLoading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                                return _createVNode(ServiceCatalogCardSkeleton, { key: n });
                            }), 64))
                        ]))
                        : (filteredServices.value.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredServices.value, (service) => {
                                    return (_openBlock(), _createElementBlock("article", {
                                        key: service.id,
                                        class: "group relative flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-ewhite-200 bg-white p-3 shadow-[0_1px_3px_rgba(0,0,0,0.03),0_6px_16px_rgba(0,0,0,0.02)] transition-all duration-300 ease-out hover:-translate-y-1 hover:border-ewhite-300 hover:shadow-[0_12px_28px_rgba(0,0,0,0.08),0_4px_12px_rgba(0,0,0,0.03)]",
                                        onClick: ($event) => (openServiceDetail(service))
                                    }, [
                                        _createElementVNode("div", _hoisted_16, [
                                            (firstPhoto(service))
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: firstPhoto(service) ?? '',
                                                    alt: service.name,
                                                    class: "h-full w-full object-cover transition duration-500 ease-out group-hover:scale-[1.04]"
                                                }, null, 8, _hoisted_17))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                    _createElementVNode("div", _hoisted_19, [
                                                        _createVNode(_unref(IconPhoto), {
                                                            class: "h-6 w-6 text-eblack-400",
                                                            stroke: "1.5"
                                                        })
                                                    ]),
                                                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("services.auto.sin_imagen", "Sin imagen")), 1)
                                                ])),
                                            (service.category?.name)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(service.category.name), 1))
                                                : _createCommentVNode("", true),
                                            (canCreateConversation.value)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 3,
                                                    type: "button",
                                                    "data-testid": "catalog-prebooking-chat",
                                                    class: "absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full border border-white/40 bg-white/85 text-eblack-800 shadow-[0_2px_8px_rgba(0,0,0,0.08)] ring-1 ring-black/[0.04] backdrop-blur-md transition-all duration-200 hover:scale-105 hover:bg-white hover:text-eblack-950 active:scale-95 disabled:cursor-not-allowed disabled:opacity-60",
                                                    disabled: _unref(isCreatingConversation),
                                                    "aria-label": _ctx.$t('services.auto.chat'),
                                                    onClick: _withModifiers(($event) => (openPreBookingChat(service)), ["stop"])
                                                }, [
                                                    _createVNode(_unref(IconMessageCircle), {
                                                        class: "h-4 w-4",
                                                        stroke: "1.75"
                                                    })
                                                ], 8, _hoisted_22))
                                                : _createCommentVNode("", true),
                                            (servicePhotoUrls(service).length > 1)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                    _createElementVNode("div", _hoisted_24, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(servicePhotoUrls(service), (url, index) => {
                                                            return (_openBlock(), _createElementBlock("span", {
                                                                key: url,
                                                                class: _normalizeClass(["h-1.5 rounded-full transition-all duration-300", index === 0 ? 'w-3 bg-white' : 'w-1.5 bg-white/60'])
                                                            }, null, 2));
                                                        }), 128))
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_25, [
                                            _createElementVNode("div", _hoisted_26, [
                                                _createElementVNode("h2", _hoisted_27, _toDisplayString(service.name), 1),
                                                (service.reviewCount && service.reviewCount > 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                                        _cache[3] || (_cache[3] = _createElementVNode("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            class: "h-3.5 w-3.5 flex-shrink-0 fill-eblack-900 text-eblack-900",
                                                            viewBox: "0 0 24 24",
                                                            "aria-hidden": "true"
                                                        }, [
                                                            _createElementVNode("path", { d: "M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" })
                                                        ], -1)),
                                                        _createElementVNode("span", null, _toDisplayString(service.averageRating?.toFixed(1)), 1),
                                                        _createElementVNode("span", _hoisted_29, "(" + _toDisplayString(service.reviewCount) + ")", 1)
                                                    ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                        _cache[4] || (_cache[4] = _createElementVNode("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            class: "h-3.5 w-3.5 flex-shrink-0 fill-amber-400 text-amber-400",
                                                            viewBox: "0 0 24 24",
                                                            "aria-hidden": "true"
                                                        }, [
                                                            _createElementVNode("path", { d: "M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" })
                                                        ], -1)),
                                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("reviews.catalog.no_reviews")), 1)
                                                    ]))
                                            ]),
                                            _createElementVNode("p", _hoisted_31, _toDisplayString(service.provider?.name || "Proveedor"), 1),
                                            _createElementVNode("p", _hoisted_32, _toDisplayString(locationLabel(service) || "Ubicación no especificada"), 1),
                                            _createElementVNode("p", _hoisted_33, [
                                                _createElementVNode("span", null, _toDisplayString(durationLabel(service.duration)), 1),
                                                (service.category?.name)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "mx-1.5 text-eblack-300" }, "·", -1)),
                                                        _createElementVNode("span", null, _toDisplayString(service.category.name), 1)
                                                    ], 64))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_34, [
                                                _createElementVNode("div", _hoisted_35, [
                                                    (priceRanges.value[service.id])
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                                                            _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t("services.auto.desde")), 1),
                                                            _createElementVNode("span", _hoisted_38, _toDisplayString(priceRanges.value[service.id].amount), 1),
                                                            _createElementVNode("span", _hoisted_39, _toDisplayString(priceRanges.value[service.id].priceType === "HOUR"
                                                                ? _ctx.$t("services.auto.por_hora")
                                                                : _ctx.$t("services.auto.por_persona")), 1)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (commissionAmounts.value[service.id])
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("services.auto.desde")), 1),
                                                            _createElementVNode("span", _hoisted_41, _toDisplayString(commissionAmounts.value[service.id]), 1),
                                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("services.auto.comision_label")), 1)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (!priceRanges.value[service.id] &&
                                                        !commissionAmounts.value[service.id] &&
                                                        service.service_type?.name)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(service.service_type.name), 1))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("div", _hoisted_43, [
                                                    (service.id != null)
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 0,
                                                            type: "button",
                                                            class: "inline-flex h-8 w-8 items-center justify-center rounded-full text-eblack-500 transition hover:bg-ewhite-100 hover:text-eblack-900 active:scale-95",
                                                            title: _ctx.$t('services.auto.ver_horarios'),
                                                            "aria-label": _ctx.$t('services.auto.ver_horarios'),
                                                            onClick: _withModifiers(($event) => (openServiceSchedule(service)), ["stop"])
                                                        }, [
                                                            _createVNode(_unref(IconCalendarEvent), {
                                                                class: "h-4 w-4",
                                                                stroke: "1.75"
                                                            })
                                                        ], 8, _hoisted_44))
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "group/btn inline-flex items-center gap-1.5 rounded-full bg-eblack-900 px-3.5 py-1.5 text-xs font-semibold text-white shadow-sm transition-all duration-200 hover:bg-black hover:shadow-md active:scale-95",
                                                        onClick: _withModifiers(($event) => (openServiceDetail(service)), ["stop"])
                                                    }, [
                                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("services.auto.ver_detalle")), 1),
                                                        _cache[6] || (_cache[6] = _createElementVNode("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            class: "h-3.5 w-3.5 transition-transform duration-200 group-hover/btn:translate-x-0.5",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            "stroke-width": "2.2",
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round",
                                                            "aria-hidden": "true"
                                                        }, [
                                                            _createElementVNode("path", { d: "M5 12l14 0" }),
                                                            _createElementVNode("path", { d: "M13 18l6 -6" }),
                                                            _createElementVNode("path", { d: "M13 6l6 6" })
                                                        ], -1))
                                                    ], 8, _hoisted_45)
                                                ])
                                            ])
                                        ])
                                    ], 8, _hoisted_15));
                                }), 128))
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                _createElementVNode("div", _hoisted_47, [
                                    _createVNode(_unref(IconSearch), { class: "h-8 w-8 text-eblack-300" })
                                ]),
                                _createElementVNode("h2", _hoisted_48, _toDisplayString(_ctx.$t("services.auto.no_se_encontraron_servicios")), 1),
                                _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.$t("services.auto.sin_resultados_ayuda")), 1),
                                (hasActiveFilters.value)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "mt-6 rounded-lg border border-ewhite-300 px-4 py-2 text-sm font-semibold text-eblack-900 transition hover:bg-ewhite-100",
                                        onClick: clearFilters
                                    }, _toDisplayString(_ctx.$t("services.auto.limpiar_filtros")), 1))
                                    : _createCommentVNode("", true)
                            ]))
            ]));
        };
    }
});
